import { ApplicationRoles } from '../../../constants/applicationRoles.ts';
import applicationRoutes from '../../../constants/applicationRoutes.ts';
import Layout from '../../../app/Layout.tsx';
import { RouteAuthenticationRequirement, RouteItem } from '@cks-internal/react-base';

export const GroupNavItems: RouteItem = {
  text: 'Groups',
  allowedRoles: [ApplicationRoles.groups],
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  layout: <Layout />,
  subItems: [
    {
      text: 'Manage Company Projects',
      path: applicationRoutes.crm.companyProject.list,
      allowedRoles: [ApplicationRoles.groups],
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      async lazy() {
        const component = await import('../../../features/groups/GroupsManagement.tsx');
        return { Component: component.GroupsManagement };
      }
    },
    {
      text: 'Project Dashboard',
      path: applicationRoutes.groups.projectDashboard,
      allowedRoles: [ApplicationRoles.groups, ApplicationRoles.sourcingManager],
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      async lazy() {
        const component = await import('../../../features/companyProjects/navigation/ProjectDashboardPage.tsx');
        return { Component: component.ProjectDashboardPage };
      }
    },
    {
      text: 'Contract Templates',
      path: applicationRoutes.groups.contractTemplates,
      allowedRoles: [ApplicationRoles.sourcingManager],
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      async lazy() {
        const component = await import('../../../features/companyProjects/contractTemplates/ContractTemplatesPage.tsx');
        return { Component: component.ContractTemplatesPage };
      }
    },
    {
      text: 'Bookings',
      path: applicationRoutes.groups.bookings,
      allowedRoles: [ApplicationRoles.groups],
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      async lazy() {
        const component = await import('../../../features/groups/GroupBookings.tsx');
        return { Component: component.GroupBookings };
      }
    },
    {
      path: applicationRoutes.groups.hotelSearch,
      allowedRoles: [ApplicationRoles.groups],
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      async lazy() {
        const component = await import('../../../features/groups/bookings/GroupHotelSearchContainer.tsx');
        return { Component: component.GroupHotelSearchContainer };
      }
    }
  ]
};
